<template>
	<i class="fa-solid fa-xmark"></i>
</template>

<script>
export default {
	name: "XmarkIcon"
}
</script>

<style scoped>

</style>
